import Component from './Component';
import { onScroll, onResizeDebounced, enableScroll, disableScroll } from '../services/ScrollResizeHandler';
import { onKeyDown } from '../services/DocumentEvents';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

const OFFSET = 50;
let prevScroll = 0;
let currentScroll = document.body.getBoundingClientRect().top;
let handleTransition;
let rafTimer;


/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Header extends Component {

  decorator () {
    return {
      selector : '.js-header',
      name : 'Header',
    }
  }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        // this.cacheElements();

        // LISTEN TO SCROLL
        onScroll(this.stickyHeader.bind(this))
    }


    // STICK HEADER
    stickyHeader (scrollObject) {
        const _headerHeight = this.element.getBoundingClientRect().height;
        let scrollDirection;
        currentScroll = scrollObject.scrollY;

        const sticky = () => {

            clearTimeout(handleTransition);

            if (scrollObject.scrollY >= _headerHeight + OFFSET) {
                this.setToFixed();
            } else if (scrollObject.scrollY < _headerHeight && currentScroll < prevScroll) {
                this.setToDefault(scrollObject);
            }

            prevScroll = currentScroll;
        }

        cancelAnimationFrame(rafTimer);

        rafTimer = window.requestAnimationFrame(sticky);
    }


    // Set fixed position of header
    setToFixed () {
        this.element.classList.add('is-fixed');

        setTimeout(() => {
            this.element.classList.add('is-visible', 'has-transition');
        }, 10);
    }


    // Set to default state
    setToDefault (scrollObject) {
        this.element.classList.remove('is-visible');

        setTimeout(() => {
            this.element.classList.remove('is-fixed', 'is-visible', 'has-transition');
        }, 350);
    }


}
